import { toast } from 'react-toastify'

import api from '@/services/api'
import apiEndPoints from '@/consts/apiEndPoints'
import handleErrors from '@/services/handleErrors'

import { confirmationDialog } from '@/components/ConfirmationDialog'

export async function createVehicle(data) {
  try {
    const response = await api.post(apiEndPoints.vehicles.root, {
      vehicle: {
        wev_placa: data.wev_placa,
        wev_ativo: data.wev_ativo,
        id_tipo_caminhao: data.id_tipo_caminhao,
      },
    })

    toast.success('Veículo salvo')

    const vehicle = response.data

    return vehicle
  } catch (error) {
    handleErrors(error, 'Não foi possível salvar o veículo')
  }
}

export async function updateVehicle(vehicleId, data) {
  try {
    const response = await api.put(
      apiEndPoints.vehicles.root.concat(`/${vehicleId}`),
      {
        vehicle: {
          wev_placa: data.wev_placa,
          wev_ativo: data.wev_ativo,
          id_tipo_caminhao: data.id_tipo_caminhao,
        },
      }
    )

    toast.success('Veículo atualizado')

    const updatedVehicle = response.data

    return updatedVehicle
  } catch (error) {
    handleErrors(error, 'Não foi possível atualizar o veículo')
  }
}

export async function deleteVehicle(vehicleId, vehiclePlate) {
  const confirm = await confirmationDialog.open(
    'Confirmar',
    `Deseja remover o veículo "${vehiclePlate}"?`
  )

  if (confirm) {
    try {
      await api.delete(apiEndPoints.vehicles.root.concat(`/${vehicleId}`))

      toast.success('Veículo removido')

      return true
    } catch (error) {
      handleErrors(error, 'Não foi possível excluir o veículo')

      return false
    } finally {
      confirmationDialog.close()
    }
  }

  confirmationDialog.close()

  return false
}
